import { actionPrefixer } from 'shared/utils/utils';

const prefix = actionPrefixer('MODAL');

export const OPEN_MODAL = prefix('OPEN_MODAL');
export const CLOSE_MODAL = prefix('CLOSE_MODAL');

export const openModal = (modalName: string) => ({
  type: OPEN_MODAL,
  payload: { modalName },
});

export const closeModal = (modalName: string) => ({
  type: CLOSE_MODAL,
  payload: { modalName },
});
